module.exports = __webpack_public_path__ + "img/svg/banner-card-arrow.44172a899fb9392354ba9440bafc2910.svg";